const getDueUpState = (
  isLive,
  isWarmup,
  isSuspended,
  inningState,
  offense = {}
) => {
    const isBetweenInnings = isLive && !(isWarmup || isSuspended) && (inningState === 'Middle' || inningState === 'End');
    const {
      batter = {},
      onDeck = {},
      inHole = {}
    } = offense;
    const hasCompletePlayerData = batter.boxscoreName && onDeck.boxscoreName && inHole.boxscoreName;

    return {
        isBetweenInnings,
        hasCompletePlayerData,
        batter,
        onDeck,
        inHole
    };
};

export default getDueUpState;
